import * as React from 'react';
import { CONSTANTS } from '../../../assets/UIConstants';

interface Props {
    size?: number;
    color?: string;
}

class QuestionMarkIcon extends React.Component<Props, {}> {

    public static defaultProps: Partial<Props> = {
        color: CONSTANTS.COLORS.THEME_BLUE,
        size: 16,
    };

    public render(): JSX.Element {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.69 15.98" width={this.props.size} height={this.props.size}>
                <path fill={this.props.color} d="M1.33,1.41A4.76,4.76,0,0,1,5,0,4.81,4.81,0,0,1,8.4,1.21,4,4,0,0,1,9.69,4.3a3.3,3.3,0,0,1-.47,1.85A14.22,14.22,0,0,1,7.31,8.23,6.17,6.17,0,0,0,5.94,9.92a5.11,5.11,0,0,0-.32,2H3.71a7,7,0,0,1,.37-2.48A6.56,6.56,0,0,1,5.7,7.34l.88-.85a3.71,3.71,0,0,0,.64-.76,2.66,2.66,0,0,0,.45-1.45A2.77,2.77,0,0,0,7,2.45a2.61,2.61,0,0,0-2.12-.77A2.61,2.61,0,0,0,2.36,3a5.08,5.08,0,0,0-.45,2.14H0A5.23,5.23,0,0,1,1.33,1.41ZM3.66,13.75H5.8V16H3.66Z" />
            </svg>
        );
    }
}



export default QuestionMarkIcon;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/components/svgs/QuestionMarkIcon.tsx